import { Injectable } from '@angular/core';
import { UpdateType } from '../../public-api';

@Injectable({
  providedIn: 'root'
})
export class UserProfileUpdateService {
  private updates: Array<UpdateType> = [];

  addUpdate(update: UpdateType): void {
    this.updates.push(update);
  }

  getUpdates(): Array<UpdateType> {
    return this.updates;
  }

  resetUpdates(): void {
    this.updates = [];
  }
}
